import { Head, Link, useForm, usePage } from "@inertiajs/react";
import AuthLayout from "@/layouts/auth-layout";
import { manage_organizations_path, users_path } from "@/routes";

function roleLabel(role = "") {
  return role.replace(/Role$/, "").replace(/([a-z])([A-Z])/g, "$1 $2");
}

export default function InvitationFormPage({
  invitation = {},
  title,
  eyebrow,
  description,
  backHref,
  submitPath,
  breadcrumbs,
  organizationLocked = false
}) {
  const { current_tenant, organizations = [], roles = [] } = usePage().props;
  const organizationName = organizations.find((organization) => `${organization.id}` === `${invitation.organization_id}`)?.name || current_tenant?.name;
  const { data, setData, post, processing } = useForm({
    email: invitation.email || "",
    role: invitation.role || roles[0] || "",
    organization_id: invitation.organization_id || current_tenant?.id || organizations[0]?.id || ""
  });

  const submit = (event) => {
    event.preventDefault();
    post(submitPath);
  };

  return (
    <>
      <Head title={title} />

      <section className="workspace-content">
        {invitation?.errors?.length > 0 ? (
          <div className="alert alert-danger">{invitation.errors.join(", ")}</div>
        ) : null}

        <div className="card">
          <div className="card-body">
            <div className="workspace-section__eyebrow">{eyebrow}</div>
            <h2 className="workspace-section__title">{title}</h2>
            <p className="workspace-admin-copy">{description}</p>

            <form onSubmit={submit} className="vstack gap-4 mt-4">
              <div>
                <label className="form-label fw-semibold">E-mail</label>
                <input
                  type="email"
                  className="form-control"
                  value={data.email}
                  onChange={(event) => setData("email", event.target.value)}
                  placeholder="navn@firma.dk"
                  required
                />
              </div>

              <div>
                <label className="form-label fw-semibold">Rolle</label>
                <select
                  className="form-select"
                  value={data.role}
                  onChange={(event) => setData("role", event.target.value)}
                  required
                >
                  <option value="" disabled>Vælg rolle</option>
                  {roles.map((role) => (
                    <option key={role} value={role}>
                      {roleLabel(role)}
                    </option>
                  ))}
                </select>
              </div>

              {organizationLocked ? (
                <>
                  <input type="hidden" name="organization_id" value={data.organization_id} />
                  <div className="workspace-admin-list__empty">
                    <div className="workspace-admin-list__title">{organizationName}</div>
                    <div className="workspace-admin-list__meta">
                      Invitationen bliver oprettet i den aktive organisation.
                    </div>
                  </div>
                </>
              ) : (
                <div>
                  <label className="form-label fw-semibold">Organisation</label>
                  <select
                    className="form-select"
                    value={data.organization_id}
                    onChange={(event) => setData("organization_id", event.target.value)}
                    required
                  >
                    <option value="" disabled>Vælg organisation</option>
                    {organizations.map((organization) => (
                      <option key={organization.id} value={organization.id}>
                        {organization.name}
                      </option>
                    ))}
                  </select>
                </div>
              )}

              <div className="d-flex flex-column flex-sm-row gap-2 justify-content-end">
                <Link href={backHref} className="btn btn-outline-secondary">
                  Annuller
                </Link>
                <button type="submit" className="btn btn-primary" disabled={processing}>
                  {processing ? "Sender..." : "Send invitation"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
}

export function DefaultInvitationLayout({ page, title, backHref, breadcrumbs }) {
  return (
    <AuthLayout
      header={{
        breadcrumbs,
        title,
        actions: [
          {
            href: backHref,
            label: "Tilbage",
            variant: "outline-secondary"
          }
        ]
      }}
    >
      {page}
    </AuthLayout>
  );
}

export function defaultInvitationBackHref({ currentTenant }) {
  return currentTenant?.id ? users_path() : manage_organizations_path();
}
